import React from "react";
import { Star } from "lucide-react";

/* -------------------------
   USER HELPERS
--------------------------*/

// Get initials from full name
export const getInitials = (name, maxLength = 2) => {
  if (!name) return "U";

  return name
    .trim()
    .split(" ")
    .map(n => n[0])
    .join("")
    .toUpperCase()
    .slice(0, maxLength);
};

// Check if avatar URL is valid
export const isValidAvatar = (avatar, imageError = false) => {
  if (!avatar || imageError) return false;

  return (
    !avatar.includes("dicebear") &&
    !avatar.includes("placeholder") &&
    !avatar.includes("default")
  );
};

/* -------------------------
   RATING HELPERS
--------------------------*/

// Render star rating JSX
export const renderStars = (rating = 0) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;

  for (let i = 0; i < 5; i++) {
    if (i < fullStars) {
      stars.push(
        <Star
          key={i}
          className="w-5 h-5 fill-yellow-500 text-yellow-500"
        />
      );
    } else if (i === fullStars && hasHalfStar) {
      stars.push(
        <div
          key={i}
          className="relative inline-block"
          style={{ width: "20px", height: "20px" }}
        >
          <Star className="absolute w-5 h-5 text-gray-300" />
          <div className="absolute overflow-hidden" style={{ width: "50%" }}>
            <Star className="w-5 h-5 fill-yellow-500 text-yellow-500" />
          </div>
        </div>
      );
    } else {
      stars.push(
        <Star
          key={i}
          className="w-5 h-5 text-gray-300"
        />
      );
    }
  }

  return stars;
};


export const formatDate = (dateStr) => {
  try {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    if (isNaN(date)) return "-";

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return "-";
  }
};
